import axiosOverlay from "../../js/axiosOverlay";

const state = {
    partenaires: null,
    entrees: null,
    programmes: null
};

const getters = {
    partenaires: state => state.partenaires,
    entrees: state => state.entrees,
    programmes: state => state.programmes
};

const mutations = {
    SET_PARTENAIRES(state, partenaires) {
        state.partenaires = partenaires;
    },
    SET_ENTREES(state, entrees) {
        state.entrees = entrees;
    },
    SET_PROGRAMMES(state, programmes) {
        state.programmes = programmes;
    }
};

const actions = {
    async loadPartenairesFromAPI({ commit, state }, tier) {
        if (state.partenaires == null) {
            let config = {
                method: 'get',
                url: process.env.VUE_APP_API_URL + "/partenaires?tiers=" + tier,
                headers: { }
            };

            try {
                const response = await axiosOverlay(config);
                let result = JSON.stringify(response.data);
                let temp = JSON.parse(result);
                
                commit('SET_PARTENAIRES', result);
                
                let entrees = temp.filter(part => part.programme === null).map((item) => {
                    return item.entree
                });
                commit('SET_ENTREES', entrees);

                temp = JSON.parse(result);
                let progs = temp.filter(part => part.programme != null).map((item) => {
                    return item.programme
                });
                let uniquePrograms = Array.from(new Set(progs));
                commit('SET_PROGRAMMES', uniquePrograms);
                
            } catch (error) {
                console.log(error);
            }
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
